import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=62e84a1d&scoped=true&"
import script from "./Chats.vue?vue&type=script&lang=js&"
export * from "./Chats.vue?vue&type=script&lang=js&"
import style0 from "./Chats.vue?vue&type=style&index=0&id=62e84a1d&prod&lang=scss&scoped=true&"
import style1 from "./Chats.vue?vue&type=style&index=1&id=62e84a1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e84a1d",
  null
  
)

export default component.exports